/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */

export type TrainWithMeDataEnumsBillingPeriod = typeof TrainWithMeDataEnumsBillingPeriod[keyof typeof TrainWithMeDataEnumsBillingPeriod];


export const TrainWithMeDataEnumsBillingPeriod = {
  Monthly: 'Monthly',
  Annual: 'Annual',
} as const;
